import { useEffect } from 'react';

export function useOverlayScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return undefined;

    const body = document.body;
    const root = document.documentElement;
    const lockCount = Number(body.dataset.overlayScrollLocks ?? '0') + 1;
    body.dataset.overlayScrollLocks = String(lockCount);
    root.classList.add('overlay-scroll-lock');
    body.classList.add('overlay-scroll-lock');

    return () => {
      const nextLockCount = Math.max(0, Number(body.dataset.overlayScrollLocks ?? '1') - 1);
      if (nextLockCount === 0) {
        delete body.dataset.overlayScrollLocks;
        root.classList.remove('overlay-scroll-lock');
        body.classList.remove('overlay-scroll-lock');
        return;
      }
      body.dataset.overlayScrollLocks = String(nextLockCount);
    };
  }, [locked]);
}
